// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2y-1";
export var movingGradient = "_2y-4";
export var movingGradientBlock = "_2y-2";
export var skeleton = "_2y-0";
export var skeletonText = "_2y-3";